import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import LoadingSpinner from '../ui/LoadingSpinner';

const styleSheet = theme => ({
  root: {
    //marginLeft: -210,
    flexGrow: 1,
    padding: 20,
    position: 'absolute',
    top: '50px',
    left: '0px',
    width: 'calc(100% - 40px)',
  },
});

class MagicLinkHome extends Component {
  state = {
    therender: 'spin'
  }

  componentDidMount() {
    const { isAuthenticated, callPartnerApi, logoutWithoutRedirect } = this.props.auth;
 
    if (isAuthenticated()) {
      // Logout current user
      logoutWithoutRedirect();
    }
   
    const params = new URLSearchParams(this.props.location.search);
    let theMl = params.get("ml");
    if (theMl != null) {
      callPartnerApi('appbind/ml/' + theMl,
                      'GET',
                      null,
                      true)
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (!data.aResult) {
          //we return failed loggins special - here we are throwing to catch block to handle.
          throw data;
        }
        let authResult = data.aResult.body;
        let link       = data.link;

        if ((link.startsWith("/stepperresumecustomer")) || (link.startsWith("/steppercustomerauthorize")) || link.startsWith("authonlyauthorize")) {
          //this saves the item.  After the user completes tasks on stepper resume, they should not go back there
          //this saves the account_link_id so the stepper resume can update it back to /myapps
          localStorage.setItem("ml", theMl);
        }

        this.props.auth.setAuthentication(authResult, link);
      })
      .catch(err => {
        if (err.message) {
          if (err.link && err.link.length > 0) {
            localStorage.setItem('redirectAfterLogin', err.link);
          }
        }
        this.setState({therender: 'home'});
        //let anError = err;
      });
    } else {
      this.setState({therender: 'home'});
    }
  }

  render() {
    /*
    const { isAuthenticated } = this.props.auth;
    if (!isAuthenticated()) {
      return (
        <Redirect to='/home' />
      );
    }
    return <div>It worked!</div>
    */
    if (this.state.therender === 'spin') {
      return (
        <div><LoadingSpinner/></div>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

export default withStyles(styleSheet)(MagicLinkHome);
